import React from 'react';
import clsx from 'clsx';
import styles from './StatusPill.module.scss';

export type StatusPillTone = 'neutral' | 'success' | 'progress' | 'warning' | 'error';

interface StatusPillProps {
    label: string;
    tone: StatusPillTone;
    className?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ label, tone, className }) => (
    <span className={clsx(styles.root, styles[tone], className)}>
        <span className={styles.dot} />
        {label}
    </span>
);

export default StatusPill;
